import { render, staticRenderFns } from "./DocumentsSignModal.vue?vue&type=template&id=c0a3e9f8&scoped=true"
import script from "./DocumentsSignModal.vue?vue&type=script&lang=js"
export * from "./DocumentsSignModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSignModal.vue?vue&type=style&index=0&id=c0a3e9f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a3e9f8",
  null
  
)

export default component.exports